// 査定提案機能の提供停止（Trello #147）。
// web 側（#146）で査定メッセージの受信箱を外したのに合わせ、プランナー側でも
// 査定提案の導線（メニュー・未提案の物件・送信予定・登録）、再送信、テンプレートの査定欄を出さない。
// 実装と既存データは削除しない。提案済みの物件の一覧・詳細（/properties/proposed）はメニュー・パンくずには出さず、
// URL と提案履歴（ユーザー詳細・マッチ詳細）からのみ到達できる閲覧専用の画面として残す。
// API 側も ASSESSMENT_PROPOSALS_ENABLED（検証・本番の既定は停止）で作成・再送信・添付を 403 にしている。
// 再開するときは、SSM の `/<env>/assessment-proposals-enabled` を true に書き換え → 値は boot 時に確定するため
// API と worker の両方を再デプロイして完了を待つ → この定数を true に戻してデプロイ、の順で行う（infra/ssm.tf 参照）。
// 停止は逆に agent（この定数）→ API（api-service と worker の両方を再デプロイ）の順。
// 順序を守れば、画面は出るのに API が 403 を返す期間が生まれない。
export const ASSESSMENT_PROPOSALS_ENABLED = false as boolean;
